import { render, staticRenderFns } from "./NewChangeOrder.vue?vue&type=template&id=31480ab3"
import script from "./NewChangeOrder.vue?vue&type=script&lang=js"
export * from "./NewChangeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports